import React, { Component } from "react";
import { Link } from "react-router-dom";
import menuIcon from "../../assets/images/menu-icon.svg";
import menuCloseIcon from "../../assets/images/menu-close-icon.svg";
import logo from "../../assets/images/callgage-gradient-logo.png";
import mobileLogo from "../../assets/images/callgage-gradient-logo-mobile.png";
import "../../styles/navmenu/NavMenu.css";
import $ from "jquery";

export default class NavMenu extends Component {
  constructor(props) {
    super(props);

    this.lastScrollPos = $(window).scrollTop();

    $(window).on("resize", this.onResize.bind(this));
    $(window).on("scroll", this.onScroll.bind(this));
  }

  // On Scroll
  onScroll() {
    var currentScrollPos = $(window).scrollTop();
    if (currentScrollPos > this.lastScrollPos) {
      $(".NavMenu .menu-icon").addClass("hidden");
    } else {
      $(".NavMenu .menu-icon").removeClass("hidden");
    }
    this.lastScrollPos = currentScrollPos;
  }

  // Open the Menu
  openMenu() {
    $(".NavMenu .overlay-container").removeClass("fast-close");
    $(".NavMenu .page-cover").removeClass("fast-close");
    $(".NavMenu .overlay-container").addClass("open");
    $(".NavMenu .page-cover").addClass("open");
  }

  // Close the menu
  closeMenu() {
    $(".NavMenu .overlay-container").removeClass("open");
    $(".NavMenu .page-cover").removeClass("open");
  }

  // Check whether the menu is open or not
  isMenuOpen() {
    var hasClass = $(".NavMenu .overlay-container").hasClass("open");
    return hasClass;
  }

  // Clicking a mobile link
  mobileLinkClick(self, page) {
    if (window.location.pathname === page) {
      self.closeMenu();
    }
  }

  /**
   * If you have the mobile nav menu open,
   * but then you're screen size is too large for the
   * navmenu, close it.
   */
  onResize() {
    if (window.innerWidth > 968) {
      $(".NavMenu .overlay-container").removeClass("open");
      $(".NavMenu .page-cover").removeClass("open");
    }
  }

  render() {
    return (
      <div className="NavMenu gutters">
        {/* Desktop Navigation */}
        <div className="link-container">
          <Link className="g-sub-text" to="/">
            HOME
          </Link>
          <Link className="g-sub-text" to="about">
            ABOUT US
          </Link>
        </div>
        <Link className="g-button contact-button" to="contact">
          Say Hello
        </Link>

        {/* Mobile Navigation */}
        <img
          src={menuIcon}
          className="menu-icon"
          onClick={this.openMenu.bind(this)}
          alt="Open the menu."
        />

        <div className={`page-cover`} />

        <div className={`overlay-container`}>
          <img
            className="menu-close-icon"
            src={menuCloseIcon}
            onClick={this.closeMenu.bind(this)}
            alt="Close the menu."
          />
          <img className="logo desktop" src={logo} alt="Callgage logo" />
          <img className="logo mobile" src={mobileLogo} alt="Callgage logo" />
          <div className="overlay-link-container">
            <Link
              className="g-sub-text"
              to="/"
              onClick={() => this.mobileLinkClick(this, "/")}
            >
              HOME
            </Link>
            <Link
              className="g-sub-text"
              to="about"
              onClick={() => this.mobileLinkClick(this, "/about")}
            >
              ABOUT US
            </Link>

            <Link
              className="g-sub-text"
              to="contact"
              onClick={() => this.mobileLinkClick(this, "/contact")}
            >
              CONTACT US
            </Link>
          </div>
        </div>
      </div>
    );
  }
}
